
import Vue from 'vue';
export default async function () {
    //Tries to refresh the token if it expires in the next 90 seconds
    //and returns the current one
    await Vue.$keycloak.updateToken(90);
    return Vue.$keycloak.token;
}